(function () {
    'use strict';

    angular.module("imApp").factory("businessCoService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1509,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1510,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
